import { styled, LegacyBox } from '@gogame/components';

const ResizeVerticalDot = styled('span')`
  width: 1px;
  height: 1px;
  margin: 3px 4px;
  background-color: ${({ theme }) => theme.palette.text.icon};
`;

export const CellHandleComponent = styled((props) => {
  return (
    <LegacyBox
      vertical={true}
      justifyContent={'center'}
      align={'center'}
      {...props}
    >
      <LegacyBox vertical={true}>
        <ResizeVerticalDot />
        <ResizeVerticalDot />
        <ResizeVerticalDot />
      </LegacyBox>
    </LegacyBox>
  );
})`
  height: 100%;
  cursor: col-resize;
  position: absolute;
  right: -10px;
  user-select: none;
  width: 20px;
  z-index: 2;
  @media screen and (max-width: 1440px) {
    display: none;
  }
`;

export const ChartContainer = styled(LegacyBox)`
  position: relative;
`;

export const ChartsContainer = styled(LegacyBox)`
  @media screen and (max-width: 1440px) {
    flex-direction: column;
  }
`;
